import React, { useState, useEffect } from 'react'
import { PropsInput } from '../../Types'
interface Props {
    onChange?: Function
    config?: PropsInput
    className?: string
    inputType?: string
    min?: string
    max?: string
    inputName?: string
    label?: string
}

export default function Input({ config, onChange, className, inputType, min, max, inputName, label }: Props): JSX.Element {
    const { usingRange } = config
    const [state, setState] = useState({
        value: '',
        valueColor: '',
        targetColor: '',
        target: '',
        title: '',
        stopsColor1: '',
        stopsColor2: '',
        stopsColor3: '',
        stopsValue1: '',
        stopsValue2: '',
        stopsValue3: '',
        unit: ''
    })

    useEffect(() => {
        if (!usingRange) {
            for (const [key] of Object.entries(state)) {
                if (key.includes('stops')) {
                    setState({ ...state, [key]: '' })
                    onChange(key, '')
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [usingRange])

    const handleInputChange = (e): void => {
        const { name, value } = e.target
        setState({ ...state, [name]: value })
        onChange([name], value)
    }

    const handleKeyUp = (e): void => {
        const { name, value } = e.target
        if (e.key === 'Enter' || e.key === 13) {
            onChange([name], value)
        }
    }

    return (
        <div className="input-container">
            <label htmlFor={label}>
                {label === 'Value' || label === 'Target' ? (
                    <span className="regular tooltip-info">
                        {label} <i className="fa fa-info-circle help-tip"></i>
                    </span>
                ) : (
                    label
                )}
                <input
                    value={state[inputName] || config[inputName]}
                    className={className}
                    type={inputType}
                    min={min}
                    max={max}
                    name={inputName}
                    onChange={handleInputChange}
                    onKeyUp={handleKeyUp}
                />
            </label>
        </div>
    )

}
